<template>
  <div class="register-container">
    <h2>Înregistrare Cont Nou</h2>
    
    <form @submit.prevent="handleRegister">
      
      <div class="form-group">
        <label for="full_name">Nume Complet:</label>
        <input type="text" id="full_name" v-model="form.full_name" required />
      </div>

      <div class="form-group">
        <label for="email">Email:</label>
        <input type="email" id="email" v-model="form.email" required />
      </div>
      
      <div class="form-group">
        <label for="password">Parolă:</label>
        <input type="password" id="password" v-model="form.password" required />
      </div>
      
      <button type="submit" :disabled="loading">
        {{ loading ? 'Se înregistrează...' : 'Creează Cont' }}
      </button>
    </form>
    
    <p v-if="message" :class="{ 'success-message': isSuccess, 'error-message': !isSuccess }">
      {{ message }}
    </p>

    <div class="switch-form">
      <router-link to="/auth">Nu ai un cont? Înregistrează-te</router-link>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue';
import apiClient from '@/api.js'; // Folosim același apiClient


// Definim evenimentul pe care îl putem emite părintelui
const emit = defineEmits(['show-login', 'register-success']);

// Starea formularului
const form = ref({
  full_name: '',
  email: '',
  password: ''
});

// Starea de feedback
const loading = ref(false);
const message = ref('');
const isSuccess = ref(false);

const handleRegister = async () => {
  loading.value = true;
  message.value = '';
  isSuccess.value = false;

  try {
    // Apelăm endpoint-ul de înregistrare
    await apiClient.post('/auth/register', {
      full_name: form.value.full_name,
      email: form.value.email,
      password: form.value.password
    });

    // Succes!
    message.value = 'Cont creat cu succes! Acum te poți autentifica.';
    isSuccess.value = true;
    loading.value = false;

    // Resetăm formularul
    form.value = { full_name: '', email: '', password: '' };
    
    // Anunțăm părintele (Auth.vue) că am terminat, 
    // poate vrea să ne trimită automat la login
    emit('register-success');

  } catch (error) {
    // Eroare (ex: email duplicat)
    console.error('Eroare la înregistrare:', error.response.data.error);
    message.value = `Eroare: ${error.response.data.error}`;
    isSuccess.value = false;
    loading.value = false;
  }
};
</script>

<style scoped>
/* Putem folosi stiluri similare cu Login.vue */
.register-container {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 8px;
}
.form-group {
  margin-bottom: 15px;
}
.form-group label {
  display: block;
  margin-bottom: 5px;
}
.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}
button {
  background-color: #1C748C; /* Verde pentru creare cont */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
button:hover {
  background-color: #1C748C;
}
.success-message {
  color: green;
  margin-top: 15px;
}
.error-message {
  color: red;
  margin-top: 15px;
}
.switch-form {
  margin-top: 20px;
  text-align: center;
}
</style>